var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "copy",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.933.913H26v25.173H.933V.913Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#copy)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.575 6.07h10.22V4.547a2.44 2.44 0 0 0-.72-1.728 2.437 2.437 0 0 0-1.728-.72H4.564c-.673 0-1.284.275-1.729.72a2.437 2.437 0 0 0-.72 1.728V17.33c0 .673.276 1.285.72 1.729.445.444 1.055.72 1.729.72h1.383V9.698c0-1 .409-1.906 1.066-2.563A3.618 3.618 0 0 1 9.575 6.07Zm11.4 0h1.385c.998 0 1.905.409 2.562 1.066a3.617 3.617 0 0 1 1.066 2.562v12.783c0 .998-.408 1.906-1.066 2.563a3.618 3.618 0 0 1-2.562 1.066H9.576a3.613 3.613 0 0 1-2.562-1.066 3.618 3.618 0 0 1-1.066-2.563v-1.523H4.565a3.617 3.617 0 0 1-2.563-1.065A3.617 3.617 0 0 1 .937 17.33V4.547c0-.998.407-1.906 1.065-2.563A3.618 3.618 0 0 1 4.565.92h12.783c.998 0 1.906.407 2.563 1.065a3.618 3.618 0 0 1 1.065 2.563V6.07ZM22.36 7.25H9.576a2.44 2.44 0 0 0-1.728.72 2.438 2.438 0 0 0-.72 1.728v12.785c0 .672.276 1.284.72 1.728.444.444 1.055.72 1.728.72H22.36a2.44 2.44 0 0 0 1.728-.72c.444-.444.72-1.055.72-1.728V9.7a2.44 2.44 0 0 0-.72-1.729 2.438 2.438 0 0 0-1.728-.72Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.95966207b826639fcf061512c0fc053c.svg";
export { ForwardRef as ReactComponent };